<h1 mat-dialog-title>Error</h1>
<div mat-dialog-content class="error">
  {{data.name}}
  <p>Your changes will be discarded.</p>
</div>
<div mat-dialog-actions>
  <button  mat-button mat-raised-button color="primary" [mat-dialog-close]="data.name" cdkFocusInitial>Ok</button>
</div>